import Login from '../components/Login.vue'
import NotFound from '../pages/NotFoundPage.vue'
import PipelineAsAService from 'src/pages/PipelineAsAService.vue'
import Files from '@/pages/Files.vue'
import SelectOption from 'src/pages/SelectOption.vue'
import FullAssessment from 'src/pages/FullAssessment.vue'
import FullAssessmentReport from 'src/pages/FullAssessmentReport.vue'
import PrivacyPolicy from 'src/pages/PrivacyPolicy.vue'
import TermsUse from 'src/pages/TermsUse.vue'
import Version from "src/pages/Version.vue";
import OidcAuth from "@/components/OidcAuth.vue";
import store from "@/store";


function requireAuth (to, from, next) {
  if(store.state.isLogged) next()
  else next( {path: '/', query: { redirect: to.fullPath }} )
}

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
  },
  {
    path: '/terms-use',
    component: TermsUse,
  },
  {
    path: '/version',
    component: Version
  },
    {
    path: '/oidc',
    component: OidcAuth,
  },
  {
    path: '/full-assessment/report/:json_url(.*)',
    component: FullAssessmentReport
  },
  {
    path: '/select-option',
    name: 'SelectOption',
    beforeEnter: requireAuth,
    component: SelectOption
  },
  {
    path: '/pipeline-as-a-service',
    name: 'PipelineAsAService',
    beforeEnter: requireAuth,
    component: PipelineAsAService
  },
  {
    path: '/full-assessment',
    name: 'full_assessment',
    beforeEnter: requireAuth,
    component: FullAssessment
  },
  {
    path: '/full-assessment/report',
    name: 'full-assessment-report',
    beforeEnter: requireAuth,
    component: FullAssessmentReport
  },
  {
    path: '/user',
    name: 'User',
    beforeEnter: requireAuth,
  },
  {
    path: '/files',
    name: 'Files',
    beforeEnter: requireAuth,
    component: Files
  },
  {
    path: '*',
    component: NotFound
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
